package devxertech.com.pages.contactSection

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.Serializable

@Serializable
data class Country(
    val name: String,
    val iso: String,
    val dialCode: String,
    val flagUrl: String
)

/** Returns the bundled country list so selectors do not depend on a cross-origin API. */
suspend fun fetchCountries(): List<Country> = bundledCountryData
    .map { record ->
        Country(
            name = record.name,
            iso = record.iso,
            dialCode = record.callingCode,
            flagUrl = "https://flagcdn.com/${record.iso.lowercase()}.svg"
        )
    }
    .sortedBy { it.name }

/** Best-effort country detection; callers retain their existing first-country fallback. */
suspend fun detectUserCountryISO(): String? {
    return try {
        val response = window.fetch("https://ipwho.is/").await()
        val json = response.json().await().unsafeCast<dynamic>()
        json.country_code as String
    } catch (e: Throwable) {
        null
    }
}
